(function () {
  function initQty(root) {
    var input = root.querySelector('[data-urb-qty]');
    if (!input) return;
    root.querySelectorAll('[data-urb-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-urb-step'), 10);
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
      });
    });
  }

  function initGallery(root) {
    var track = root.querySelector('[data-urb-gallery]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-urb-slide]');
    var thumbs = root.querySelectorAll('[data-urb-thumb]');
    var prev = root.querySelector('[data-urb-gallery-prev]');
    var next = root.querySelector('[data-urb-gallery-next]');

    function goTo(i) {
      if (slides[i]) track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function current() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var idx = 0, best = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft + s.clientWidth / 2 - center);
        if (d < best) { best = d; idx = i; }
      });
      return idx;
    }
    if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, current() - 1)); });
    if (next) next.addEventListener('click', function () { goTo(Math.min(slides.length - 1, current() + 1)); });

    if (thumbs.length) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { goTo(parseInt(thumb.getAttribute('data-urb-thumb'), 10)); });
      });
      var sync = function () {
        var idx = current();
        thumbs.forEach(function (t, i) {
          var on = i === idx;
          t.classList.toggle('is-active', on);
          if (on) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
      };
      var raf;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(sync);
      }, { passive: true });
      sync();
    }

    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 4) { moved = true; track.setPointerCapture(e.pointerId); }
      track.scrollLeft = sl - dx;
    });
    track.addEventListener('pointerup', function () { down = false; });
    track.addEventListener('click', function (e) { if (moved) e.preventDefault(); }, true);
  }

  function initRail(root) {
    root.querySelectorAll('[data-urb-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-urb-rail-track]');
      if (!track) return;
      var prev = rail.querySelector('[data-urb-rail-prev]');
      var next = rail.querySelector('[data-urb-rail-next]');
      function update() {
        var max = track.scrollWidth - track.clientWidth - 1;
        rail.classList.toggle('can-left', track.scrollLeft > 1);
        rail.classList.toggle('can-right', track.scrollLeft < max);
      }
      function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      var raf;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  // Przełącznik gramatur: zdjęcie (na /en packshot EN wariantu), wysokość słoika, masa netto, metka, wariant w formularzu i ?variant= w adresie
  function initVariants(root) {
    var picks = root.querySelectorAll('[data-urb-variant]');
    if (!picks.length) return;
    var img = root.querySelector('[data-urb-main-img]');
    var slide = img ? img.closest('[data-urb-slide]') : null;
    var thumb = root.querySelector('[data-urb-thumb="0"] img');
    var metka = root.querySelector('[data-urb-metka] b');
    var idInput = root.querySelector('[data-urb-id]');
    var netto = root.querySelector('[data-urb-netto]');
    var track = root.querySelector('[data-urb-gallery]');
    // stan startowy: zdjęcie, które przyszło z serwera (dla gramatur bez własnego zdjęcia)
    var def = img ? {
      src: img.getAttribute('src'), srcset: img.getAttribute('srcset'),
      w: img.getAttribute('width'), h: img.getAttribute('height'),
      thumb: thumb ? thumb.getAttribute('src') : null,
      gram: metka ? metka.textContent : '',
      mm: slide ? slide.style.getPropertyValue('--urb-jar-mm') : ''
    } : null;

    function setImage(src, srcset, w, h, thumbSrc) {
      if (!img || img.getAttribute('src') === src) return;
      img.classList.add('is-swapping');
      var pre = new Image();
      pre.onload = pre.onerror = function () {
        img.setAttribute('srcset', srcset || '');
        img.setAttribute('src', src);
        if (w) img.setAttribute('width', w);
        if (h) img.setAttribute('height', h);
        if (thumb && thumbSrc) thumb.setAttribute('src', thumbSrc);
        img.classList.remove('is-swapping');
      };
      pre.src = src;
    }

    function select(btn, updateUrl) {
      picks.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      if (idInput) idInput.value = btn.dataset.urbVariant;
      if (img && def) {
        if (btn.dataset.img) {
          setImage(btn.dataset.img, btn.dataset.srcset, btn.dataset.w, btn.dataset.h, btn.dataset.img.replace(/width=\d+/, 'width=160'));
          if (metka) metka.textContent = btn.dataset.gram;
        } else {
          setImage(def.src, def.srcset, def.w, def.h, def.thumb);
          if (metka) metka.textContent = def.gram;
        }
      }
      if (slide && btn.dataset.mm) slide.style.setProperty('--urb-jar-mm', btn.dataset.mm);
      if (netto) {
        netto.textContent = btn.dataset.netto || '';
        netto.hidden = !btn.dataset.netto;
      }
      if (track && track.scrollLeft > 0) track.scrollTo({ left: 0, behavior: 'smooth' });
      if (updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', btn.dataset.urbVariant);
        window.history.replaceState(window.history.state, '', url.toString());
      }
    }

    picks.forEach(function (btn, i) {
      btn.addEventListener('click', function () { select(btn, true); });
      btn.addEventListener('keydown', function (e) {
        var dir = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        var nb = picks[(i + dir + picks.length) % picks.length];
        nb.focus();
        select(nb, true);
      });
      btn.tabIndex = btn.classList.contains('is-active') ? 0 : -1;
    });
  }

  function init(root) { initQty(root); initGallery(root); initRail(root); initVariants(root); }
  function boot() { document.querySelectorAll('[data-urb-phero]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-urb-phero]');
    if (el) init(el);
  });
})();
